import React from 'react';

const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/product-pod/Context');

const hasContext = () => {
  const globalSymbols = Object.getOwnPropertySymbols(global);
  return (globalSymbols.indexOf(CONTEXT_KEY) > -1);
};

const getOrCreateCardContext = (context) => {
  if (!context) {
    global[CONTEXT_KEY] = React.createContext({
      userRole: 'ADMIN',
      loyaltyYear: false,
    });
  }
  return global[CONTEXT_KEY];
};

export const cardContext = getOrCreateCardContext(hasContext());

export const exportsForTesting = {
  hasContext,
  getOrCreateCardContext,
};
